import { render, staticRenderFns } from "./PourQui.vue?vue&type=template&id=155aa924&scoped=true&"
import script from "./PourQui.vue?vue&type=script&lang=js&"
export * from "./PourQui.vue?vue&type=script&lang=js&"
import style0 from "./PourQui.vue?vue&type=style&index=0&id=155aa924&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155aa924",
  null
  
)

export default component.exports